import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ENVIRONMENT } from '@core/tokens/tokens';

@Injectable({ providedIn: 'root' })
export class GtagLoaderService {
  private loaded = false;

  private readonly platformId = inject(PLATFORM_ID);
  private readonly doc = inject(DOCUMENT);
  private readonly env = inject(ENVIRONMENT);

  /** Load GA4 gtag.js to enable gtag('get', ...) */
  load(): Promise<void> {
    if (
      !isPlatformBrowser(this.platformId) ||
      this.loaded ||
      !this.env.googleTagMeasurementKey
    )
      return Promise.resolve();

    // Prepare dataLayer + gtag shim (gtag pushes into dataLayer)
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function gtag() {
        // gtag.js requires the Arguments object itself; GA ignores an array
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      };
    window.gtag('js', new Date());

    return new Promise<void>((resolve) => {
      const s = this.doc.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(this.env.googleTagMeasurementKey)}`;
      s.onload = () => {
        // Important: avoid duplicate page_view if GTM GA4 Config also sends it
        window.gtag?.('config', this.env.googleTagMeasurementKey, {
          send_page_view: false,
        });
        this.loaded = true;
        resolve();
      };
      s.onerror = () => resolve();
      this.doc.head.appendChild(s);
    });
  }
}
